var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "BjDivider",
        {
          scopedSlots: _vm._u(
            [
              !_vm.isView
                ? {
                    key: "button",
                    fn: function () {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "xs delete-btn",
                            attrs: {
                              type: "danger",
                              disabled: _vm.selectedRows.length == 0,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onDelSelectedStore()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("delText")))]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "xs",
                            attrs: { type: "primary", disabled: _vm.disabled },
                            on: { click: _vm.getParentData },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.isSpu
                                  ? _vm.$t(
                                      "goodsClassify.dialogTable.attributes"
                                    )
                                  : _vm.$t("goodsClassify.dialogTable.superior")
                              ) + " "
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "xs",
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.$refs.GoodsAttribute.show()
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("goodsClassify.dialogTable.AddAttribute")
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  }
                : null,
            ],
            null,
            true
          ),
        },
        [_vm._v(_vm._s(_vm.$t("goodsClassify.dialogTable.titleName")) + " ")]
      ),
      _c(
        "el-table",
        {
          ref: "storeTable",
          attrs: {
            data: _vm.tableData,
            stripe: "",
            border: "",
            "header-cell-style": _vm.$rowStyle.DEFAULT,
            "row-key": "BJ_EBC_ID",
          },
          on: { "selection-change": _vm.handleSelectionChangeStore },
        },
        [
          !_vm.isView
            ? _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: "55",
                  align: "center",
                  selectable: _vm.checkSelectable,
                },
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: {
              type: "index",
              width: "60",
              align: "center",
              label: _vm.$t("table.countText"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "code",
              label: _vm.$t("goodsClassify.table.Attributecode"),
              align: "center",
              width: "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "formType",
              label: _vm.$t("goodsClassify.table.Attributemethod"),
              align: "center",
              width: "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            _vm.INPUT_BOX_TYPE_LIST.bjGet(scope.row.formType)
                          )
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "attributeValueList",
              label: _vm.$t("goodsClassify.table.Attributevalue"),
              align: "center",
              width: "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getValueString(scope.row.attributeValueList)
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "sourceType",
              label: _vm.isSpu
                ? _vm.$t("goodsClassify.table.AttributeType")
                : _vm.$t("goodsClassify.table.Attributesource"),
              align: "center",
              width: "130",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            (_vm.isSpu
                              ? _vm.GOODS_ATTRIBUTE_TYPES
                              : _vm.GOODS_ATTRIBUTE_SOURCES
                            ).bjGet(scope.row.sourceType)
                          )
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "remark",
              label: _vm.$t("table.remarkText"),
              align: "center",
              width: "160",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "skuFlag",
              label: _vm.$t("goodsClassify.table.AttributeSKU"),
              align: "center",
              width: "160",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          scope.row.skuFlag
                            ? _vm.$t("yesText")
                            : _vm.$t("noText")
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          !_vm.isView
            ? _c("el-table-column", {
                attrs: {
                  prop: "action",
                  label: _vm.$t("operationText"),
                  align: "center",
                  width: "120",
                  fixed: "right",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.$index > 3
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "delete-btn",
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onDelete(scope.row)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("delText")))]
                              )
                            : _vm._e(),
                          scope.$index > 3
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "edit-btn",
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onEdit(scope.row)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("editText")))]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2036930693
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("GoodsAttribute", {
        ref: "GoodsAttribute",
        attrs: { "set-flag": _vm.setFlag },
        on: { confirm: _vm.handleAttributeConfirm },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }